export default __webpack_public_path__ + "static/media/trebexia_footer400x50.aa5a923f.png";